<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" pagination :max-items="itemsPerPage" search :data="listRoles">
			<template slot="thead">
				<vs-th class="g-table--title" sort-key="name">{{ $t("Roles.ListView.columnsNames.Name") }}</vs-th>
				<vs-th class="g-table--title" sort-key="added">{{ $t("Roles.ListView.columnsNames.AddedOn") }}</vs-th>
				<vs-th class="g-table--title" sort-key="description"
					>{{ $t("Roles.ListView.columnsNames.Description") }}
				</vs-th>
				<vs-th class="g-table--title">{{ $t("Action") }}</vs-th>
			</template>
			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="g-table--description truncate">{{ tr.name }}</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description truncate">{{ tr.added_on }}</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description truncate">{{ tr.description }}</p>
						</vs-td>
						<vs-td class="g-table--description whitespace-no-wrap">
							<feather-icon
								class="g-label--normal"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								v-if="currenRole === 'admin'"
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr.id)"
							/>
						</vs-td>
						<template class="expand-user" slot="expand">
							<div class="con-expand-users w-full">
								<div v-for="(cat, key) in listRole_Permissions" :key="key">
									<vs-chip v-if="tr.id == cat.role_id" transparent color="primary">
										{{ cat.permission_name }}
									</vs-chip>
								</div>
							</div>
						</template>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
export default {
	name: "RolesListView",
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
			currenRole: "editor",
		};
	},
	computed: {
		// Pagina actual
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		// Retona la lista de roles del state
		listRoles() {
			return this.$store.state.moduleRoles.roles;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listRoles.length;
		},
		// Retorna la lista de permisos encontrados en el state
		listRole_Permissions() {
			return this.$store.state.moduleRoles.role_permissions;
		},
	},
	methods: {
		// Click en icono eliminar
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Roles.ListView.DeleteRole.TextToConfirm"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Se acepta la eliminación
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		// Elimina el rol
		deleteData(id) {
			this.$vs.loading();
			// Llama la accion Vuex, "removeRole" y se le envia el id del rol
			this.$store
				.dispatch("moduleRoles/removeRole", id)
				.then((res) => {
					// Respuesta exitosxa
					// cierra load
					this.$vs.loading.close();
					// Muestra mensaje de respuesta exitoso
					this.$vs.notify({
						color: "success",
						title: this.$t("Roles.ListView.DeleteRole.TitleSuccess"),
						text: this.$t("Roles.ListView.DeleteRole.TextSuccess"),
					});
				})
				.catch((err) => {
					// Respuesta erronea
					// Muestra mensaje de respta erroneo
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.ListView.DeleteRole.TitleError"),
						text: this.$t("Roles.ListView.DeleteRole.TextError"),
					});
					throw new Error(err);
				});
		},
		// Click en edicion
		editData(data) {
			// Emite un evento al padre "Roles.vue", enviando la información del rol
			this.$emit("selectedRoleEmit", data);
		},
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		this.currenRole = this.$store.state.AppActiveUser.userRole;
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		/*
          Below media-queries is fix for responsiveness of action buttons
          Note: If you change action buttons or layout of this page, Please remove below style
        */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.product-name {
			max-width: 23rem;
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

				td {
					padding: 20px;

					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}

					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}

				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
